<script>
  // @ts-check
  import DynamicHeading from "../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../atoms/DynamicHeadingContext.svelte";
  import GridContainer from "../atoms/GridContainer.svelte";
  import Link from "../atoms/Link.svelte";
  import Rule from "../atoms/Rule.svelte";
  import Fragment from "../atoms/Fragment.svelte";
  import { getTheme } from "../utilities/themes";

  /** @type { string } */
  let className = "";
  export { className as class };

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * The title of the hero section
   * @type {string}
   */
  export let title = null;

  /**
   * The call to action in the hero section
   * @type {import('../types/shared.js').CTA}
   */
  export let cta = null;

  /**
   * The theme of the hero section
   * @type {import('../utilities/themes.js').ThemeName}
   */
  export let theme = "white";
  let currentTheme = getTheme(theme);

  const themedSectionClass = theme === "white" ? "" : "pt-15 pb-7.5";
</script>

<svelte:component this={title ? DynamicHeadingContext : Fragment}>
  <section
    {id}
    class="{currentTheme?.textColor}
  {currentTheme?.backgroundColor}
  {themedSectionClass}
  {className}"
  >
    <GridContainer>
      <Rule type="thick" {theme} class="mb-7.5" />

      {#if title}
        <div class="mb-7.5 flex justify-between lg:mb-15">
          <DynamicHeading class="heading-sm">
            {title}
          </DynamicHeading>
          {#if cta}
            <Link
              class="max-md:hidden"
              href={cta.url}
              isExternal={cta.isExternal}
              label={cta.text}
              variant="small"
              {theme}
            >
              {cta?.text}
            </Link>
          {/if}
        </div>
      {/if}
    </GridContainer>

    <!-- Section content -->
    <slot />

    {#if cta}
      <GridContainer>
        <div class="mt-7.5 md:hidden">
          <Rule type="thin" {theme} />
          <Link
            class="pt-3"
            href={cta.url}
            isExternal={cta.isExternal}
            label={cta.text}
            variant="small"
            {theme}
          >
            {cta?.text}
          </Link>
        </div>
      </GridContainer>
    {/if}
  </section>
</svelte:component>
